import { useEffect, useRef, useState } from "react";
import React from "react";
import "./style.scss";
import { useWindowSize } from "@app/Helpers";
import Featured1 from "../../img/Featured1.svg?react";
import Featured2 from "../../img/Featured2.svg?react";
import Featured3 from "../../img/Featured3.svg?react";

export default function SubscriptionItem({ subscription }) {
  const { width } = useWindowSize();
  const XGA = width >= 1020;
  const [currentCategory, setCurrentCategory] = useState("Übersicht");

  function formatDate(timestamp) {
    if (!timestamp) return "-";
    const date = new Date(timestamp);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  }

  const LEVELS = ["core", "plus", "prime"];
  const DEVICES = ["vuse_go", "vuse_pods", "vuse_ultra"];

  const DEVICE_LABEL = {
    vuse_go: "Vuse Go",
    vuse_pods: "Vuse Pods",
    vuse_ultra: "Vuse Ultra Pods",
  };

  const LEVEL_LABEL = {
    core: "Core",
    plus: "Plus",
    prime: "Prime",
  };

  function plansToItems(plans) {
    if (!plans) return [];

    const items = [];

    for (const deviceKey of DEVICES) {
      const found = [];

      for (const level of LEVELS) {
        const qty = plans?.[level]?.[deviceKey] ?? 0;
        if (qty > 0) found.push({ level, qty });
      }

      if (found.length === 1) {
        items.push({
          deviceKey,
          deviceLabel: DEVICE_LABEL[deviceKey] ?? deviceKey,
          level: found[0].level,
          levelLabel: LEVEL_LABEL[found[0].level] ?? found[0].level,
          qty: found[0].qty,
        });
      }
    }

    return items;
  }

  const planItems = plansToItems(subscription?.plans);

  const orders = Object.entries(subscription?.orders ?? false).map(
    ([id, order]) => ({
      id,
      ...order,
    }),
  );

  console.log(orders);

  return (
    <div className="subscription">
      <div className="subscription-header">
        <div className="subscription-info">
          <p className="subscription-number">#{subscription.parentOrderId}</p>
          <div
            className={`subscription-status ${subscription.subscriptionStatus.toLowerCase()}`}
          >
            <div
              className={`status ${subscription.subscriptionStatus.toLowerCase()}`}
            ></div>
            <p>
              {subscription.subscriptionStatus === "Paused"
                ? "Pausiert"
                : subscription.subscriptionStatus === "Cancelled"
                  ? "Abgesagt"
                  : subscription.subscriptionStatus}
            </p>
          </div>
        </div>

        <div className="subscription-actions">
          <div className="manage-subscription">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.vuse.com/de/de/vorteils-abo/?utm_source=IC&utm_medium=Dashboard&utm_campaign=PremiumAbo"
              className="copy"
            >
              Abo verwalten
            </a>
          </div>
          <div className="tab-navigation">
            <div
              className={`tab-navigation-left ${
                currentCategory === "Übersicht" ? "active" : ""
              }`}
              onClick={() => setCurrentCategory("Übersicht")}
            >
              <p>Übersicht</p>
            </div>
            <div
              className={`tab-navigation-right ${
                currentCategory === "Bestellungen" ? "active" : ""
              }`}
              onClick={() => setCurrentCategory("Bestellungen")}
            >
              <p>Bestellungen</p>
            </div>
          </div>
        </div>
      </div>

      <div className="content">
        {currentCategory === "Übersicht" && (
          <div className="overview">
            {subscription.subscriptionStatus !== "Cancelled" && (
              <div className="overview-top">
                <div className="devlivery-date">
                  <Featured1 />
                  <p>
                    Nächste Bestellung am:
                    <span> {formatDate(subscription.nextRenewalDate)}</span>
                  </p>
                </div>
                {planItems.length > 0 && (
                  <div className="plans-list">
                    <ul className="plans">
                      {planItems.map((item) => (
                        <li key={item.deviceKey} className="plan-row">
                          <p className="plan-device">
                            <span className="plan-qty">{item.qty} × </span>
                            {item.deviceLabel}
                          </p>
                          <p className="plan-level">{item.levelLabel}</p>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}
            <div className="overview-bottom">
              <div className="plan-date">
                <Featured3 />{" "}
                <p>
                  Abo gestartet am:{" "}
                  <span>{formatDate(subscription.subscriptionStartDate)}</span>
                </p>
              </div>
              <div className="total-savings">
                <Featured2 />
                <p>
                  Gesamtersparnis:{" "}
                  <span>€ {subscription.discountAmountTotal}</span>
                </p>
              </div>
            </div>
          </div>
        )}

        {currentCategory === "Bestellungen" && (
          <div className="orders">
            <ul className="orders-list">
              <li className="order-header">
                <span className="order-column">Date</span>
                <span className="order-column">Ersparnis</span>
              </li>
              {(orders.length > 0
                ? orders
                : [
                    {
                      placeHolder:
                        "Hier erscheinen deine abgeschlossenen Bestellungen.",
                    },
                  ]
              ).map((order) => {
                const id = order.id;
                return (
                  <li key={id} className={`order-item`}>
                    <div className="order-left">
                      {order.placeHolder ? (
                        <p>{order.placeHolder}</p>
                      ) : (
                        <p className="order-date">
                          {formatDate(order.timestamp)}
                        </p>
                      )}
                    </div>
                    <div className="order-right">
                      {order.placeHolder ? null : (
                        <div className="order-savings">
                          € {order.discountSum}
                        </div>
                      )}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
